import React from 'react'
import { useNavigate } from 'react-router-dom';
import { ServerCrash } from 'lucide-react';
import ButtonComp from '../../components/ButtonComp';

interface ServerDownProps {
    title?: string;
    description?: string;
}

const ServerDown: React.FC<ServerDownProps> = ({
    title = "Server Error",
    description = "We're experiencing some technical difficulties. Our team is working on resolving the issue."
}) => {
    const navigate = useNavigate();

    return (
        <div className="w-full min-h-screen relative bg-primary-blue-80 overflow-hidden flex flex-col items-center justify-center px-4 py-8 md:py-16 text-center text-white font-text-md-medium1">
            <img
                className="absolute md:top-0 mt-auto !mx-auto object-cover opacity-[0.02] z-0"
                alt=""
                src="/logo/logomark.svg"
            />
            <div className="w-full max-w-md flex flex-col items-center justify-start gap-8 z-10">
                <ServerCrash className="w-16 h-16 md:w-24 md:h-24" />
                <div className="flex flex-col items-center justify-start gap-4 w-full">
                    <h1 className="text-3xl md:text-5xl font-medium">
                        {title}
                    </h1>
                    <p className="text-sm md:text-base text-greyscale-301">
                        {description}
                    </p>
                </div>
                <div className="w-full flex flex-col items-center justify-start gap-4">
                    <p className="text-sm md:text-base text-greyscale-301">
                        Try again later
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ServerDown;
